import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import {
    Form, Input, FormFeedback, Label, Modal, ModalHeader, ModalBody,
} from "reactstrap";


//redux
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { addRatersType, editRatersType } from "store/actions";
import { withTranslation } from "react-i18next";


const AddEditModal = props => {
    const { modal, toggle, isEdit, itemData, fetchRatersTypeListData } = props
    const [ratersTypeData, setRatersTypeData] = useState();
    const { error, success, loading ,editLoading} = useSelector(state => ({
        loading: state.configRatersType.loading,
        error: state.configRatersType.error,
        success: state.configRatersType.success,
        editLoading:state.configRatersType.editLoading
    }));
    const dispatch = useDispatch();

    useEffect(() => {
        setRatersTypeData(itemData)
    }, [itemData])

    const validation = useFormik({
        enableReinitialize: true,

        initialValues: {
            rater_type: ratersTypeData?.rater_type || '',
            is_active: ratersTypeData?.is_active || 'Y'
        },
        validationSchema: Yup.object({
            rater_type: Yup.string().required(props.t("Please Enter Raters Type")),
            is_active: Yup.string().required(props.t("Please Enter Raters Type Status")),
        }),
        onSubmit: (values, { resetForm }) => {
            if (isEdit) {
                dispatch(editRatersType(values, ratersTypeData?.id, (res) => {
                    if (res.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            rater_type: '',
                            is_active: 'Y'
                        });
                        fetchRatersTypeListData()
                        toggle()

                    } else {
                        toastr.error(res.message)
                        toggle()
                        

                    }
                }));
            } else {
                dispatch(addRatersType(values, props?.router?.navigate, (res) => {
                    if (res?.status === 'success') {
                        toastr.success(res.message)
                        
                        resetForm({
                            rater_type: '',
                            is_active: ''
                        });
                        fetchRatersTypeListData()
                        toggle()
                    } else {
                        toastr.error(res.message)
                        toggle()
                        
                    }
                }));
            }

        }
    });



    return (
        <React.Fragment>
            <Modal isOpen={modal} toggle={
                () => {
                    toggle()
                    
                }}>
                <ModalHeader tag="h4" toggle={
                    () => {
                        toggle()
                        
                    }}>
                    {!!isEdit ? props.t("Edit Rater Types") : props.t("Add Rater Types")}
                </ModalHeader>
                <ModalBody>
                    <Form
                        className="form-rater_type"
                        onSubmit={(e) => {
                            e.preventDefault();
                            validation.handleSubmit();
                            return false;
                        }}
                    >

                        <div className="mb-3 d-block">
                            <Label className="form-label m-0 pb-1">{props.t("Raters Concept")}:</Label>
                            <Input
                                name="rater_type"
                                className="form-control"
                                placeholder={props.t("Enter Raters Concept")}
                                type="text"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.rater_type || ""}
                                invalid={
                                    validation.touched.rater_type && validation.errors.rater_type ? true : false
                                }
                            />
                            {validation.touched.rater_type && validation.errors.rater_type ? (
                                <FormFeedback type="invalid">{validation.errors.rater_type}</FormFeedback>
                            ) : null}
                        </div>

                        {/* <div className="mb-3 d-flex align-items-center gap-3">
                            <Label className="form-label m-0">{props.t("Status")}:</Label>
                            <div className="d-flex align-items-center gap-2">
                                <Input
                                    id="yes"
                                    name="is_active"
                                    type="radio"
                                    checked={validation.values.is_active == 'Y' ? true : false}
                                    value="Y"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="yes" className="form-label m-0">{props.t("Active")}</Label>
                                <Input
                                    id="no"
                                    name="is_active"
                                    checked={validation.values.is_active === 'N' ? true : false}
                                    value="N"
                                    type="radio"
                                    onClick={validation.handleChange}
                                    onBlur={validation.handleBlur}
                                    invalid={
                                        validation.touched.is_active && validation.errors.is_active ? true : false
                                    }
                                />
                                <Label for="no" className="form-label m-0">{props.t("In-Active")}</Label>

                            </div>
                            {validation.touched.is_active && validation.errors.is_active ? (
                                <FormFeedback type="invalid">{validation.errors.is_active}</FormFeedback>
                            ) : null}
                        </div> */}

                        {
                            editLoading ?
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">

                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block d-flex"
                                        disabled
                                    >
                                        <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>{" "}
                                        {props.t("Submit")}
                                    </button>
                                </div>
                                :
                                <div className="btn-login-admin mt-3 batches-add-modal-btn">
                                    <button
                                        className="btn btn-primary btn-block"
                                        type="submit"
                                    // disabled
                                    >
                                        {props.t("Submit")}
                                    </button>
                                </div>
                        }
                    </Form>
                </ModalBody>
            </Modal>

        </React.Fragment>
    );
};


AddEditModal.propTypes = {
    history: PropTypes.object,
    t: PropTypes.any,

};
export default withTranslation()(AddEditModal);